export const deleteListItems = (componentData) => {
  return componentData.list.content.items.filter((listItem) => {
    return componentData.list.content.groups.some((group) => {
      return group.ID === listItem.groupIndex;
    });
  });
};
